import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'unauthorized',
  templateUrl: 'unauthorized.component.html',
  styleUrls: [],
  providers: []
})
export class UnauthorizedComponent {
  message = 'You are not authorized to use this application. If you believe you have reached this message in error, please contact your district or HCA contact.';

  constructor(private route: ActivatedRoute) {
    var message = this.route.snapshot.params['message'];

    if(message) {
      this.message = atob(message);
    }
  }
}